<template>
  <div class="active-schools">
    <h1 class="text-center my-7">نمایندگی ها</h1>
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <NavigationComponent />
      </v-col>
      <v-col cols="12" md="9" class="px-2">
        <v-card class="elevation-0 mb-5 pa-5">
          <h5>اضافه کردن نمایندگی جدید</h5>
          <v-form
            v-model="valid"
            @submit.prevent="setAgent"
            class="text-center"
          >
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="mobile"
                  autocomplete="off"
                  label="شماره همراه کاربر"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="code"
                  type="number"
                  autocomplete="off"
                  hint="کد نمایندگی از این پس به این شماره اختصاص خواهد یافت"
                  label="کد نمایندگی"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-btn
                  :loading="loading"
                  :disabled="!valid || loading"
                  depressed
                  block
                  color="primary"
                  type="submit"
                >
                  ارسال درخواست
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
        <h3 class="mb-5">لیست نمایندگی ها</h3>
        <v-data-table :headers="headers" :items="agents" :items-per-page="10">
          <template v-slot:[`item._id`]="{ item }">
            <div class="d-flex justify-center">
              <v-btn
                depressed
                small
                color="error"
                class="mr-2"
                @click="disableAgent(item._id)"
              >
                غیر فعال کردن نمایندگی
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.requestDate`]="{ item }">
            <persian-date :date="item.requestDate" />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NavigationComponent from "./_Navigation.vue";
export default {
  name: "agents-component",
  components: {
    NavigationComponent
  },
  data: () => {
    return {
      valid: true,
      loading: false,
      mobile: null,
      code: null,
      agents: [],
      headers: [
        { text: "نام", value: "firstname", align: "center" },
        { text: "نام خانوادگی", value: "lastname", align: "center" },
        { text: "شماره همراه", value: "username", align: "center" },
        { text: "کد نمایندگی", value: "agent.code", align: "center" },
        { text: "عملیات", value: "_id", align: "center" }
      ]
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api
        .get("/agent/get")
        .then((res) => {
          this.agents = res.data.agents;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    disableAgent(id) {
      const userId = id;
      this.$api
        .post("/user/diactive", {
          user: userId
        })
        .then(() => {
          this.getData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setAgent() {
      this.$api
        .post("/agent/set", {
          mobile: this.mobile
        })
        .then((res) => {
          const userId = res.data.user._id;
          this.$api
            .post("/agent/add", {
              user: userId,
              code: this.code
            })
            .then(() => {
              this.getData();
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
};
</script>
